import { forwardRef } from 'react'
import { Loader2 } from 'lucide-react'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: string
  size?: string
  loading?: boolean
  icon?: React.ComponentType<{ className?: string }>
  iconPosition?: 'left' | 'right'
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, variant = 'primary', size = 'md', loading = false, disabled = false, className = '', icon: Icon, iconPosition = 'left', ...props }, ref) => {
    const variants: Record<string, string> = { primary: 'btn-primary', secondary: 'btn-secondary', outline: 'btn-outline', danger: 'btn-danger', ghost: 'btn-ghost', warning: 'btn-primary' }
    const sizes: Record<string, string> = { sm: 'btn-sm', md: '', lg: 'btn-lg' }
    return (
      <button ref={ref} disabled={disabled || loading} className={`btn ${variants[variant] || variants.primary} ${sizes[size] || ''} ${className}`} {...props}>
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : (
          <>{Icon && iconPosition === 'left' && <Icon className="mr-2 h-4 w-4" />}{children}{Icon && iconPosition === 'right' && <Icon className="ml-2 h-4 w-4" />}</>
        )}
      </button>
    )
  }
)
Button.displayName = 'Button'
export default Button
